import { Component, DestroyRef, inject } from '@angular/core';
import { rxResource, takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, tap } from 'rxjs';
import { HasRolesDirective } from 'keycloak-angular';

import { Pagination } from '../../../utilities/classes/pagination';
import { AssetService } from '../../../services/asset';
import { SpinnerLoaderDirective } from '../../../utilities/directives/spinner-loader.directive';
import { DevicePairModal } from './device-pair-modal/device-pair-modal';
import { NotificationService } from '../../../utilities/services/notification.service';
import { DeviceFlowItem } from '../../../models/asset';
import { Permission } from '../../../models/user';

@Component({
  selector: 'fs-device-flow',
  imports: [SpinnerLoaderDirective, NgbTooltipModule, HasRolesDirective],
  templateUrl: './device-flow.html',
  styleUrl: './device-flow.scss',
})
export class DeviceFlow {
  private readonly assetService = inject(AssetService);
  private readonly modalService = inject(NgbModal);
  private readonly notificationService = inject(NotificationService);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly permission = Permission;
  protected readonly paginationData: Pagination = new Pagination();

  protected readonly deviceFlowResource = rxResource({
    params: () => this.paginationData.paginationState(),
    stream: ({ params }) => this.assetService.searchDeviceFlow(params).pipe(
      tap((response) => this.paginationData.updateTotals(response.totalElements))
    )
  });

  protected async pairModal() {
    const modalRef = this.modalService.open(DevicePairModal, { size: 'lg' });
    await modalRef.result.then((result) => {
        if (result == 'refresh') this.deviceFlowResource.reload();
    })
  }

  protected cancelPair(flow: DeviceFlowItem) {
    this.notificationService.openModal({
      title: 'Cancella Associazione',
      type: 'danger',
      message: `Sei sicuro di voler cancellare l'associazione con l'asset ${flow.assetModel.name}`,
      choice: 'multi'
    }).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((confirm) => {
      if (!confirm) return;
      this.deleteFlow(flow.id);
    });
  }

  protected deleteSubscription!: Subscription;
  private deleteFlow(flowId: number) {
    this.deleteSubscription = this.assetService.deleteDeviceFlow(flowId).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.deviceFlowResource.reload();
      this.notificationService.showToast('L\'assegnazione è stata rimossa', { type: 'success' });
    });
  }
}
